// Auto-generated from the bedd.dev catalogue.html snapshot.
// Internal hrefs rewritten to SPA paths via `.scratch/port-page.py`; nav +
// footer are composed from `marketing-shared/` so all marketing pages stay
// in lock-step. To re-port, drop a fresh snapshot at
// `.scratch/bedd-snapshot/catalogue.html` and re-run the build script.

import { navMarkup } from '../marketing-shared/nav';
import { footerMarkup } from '../marketing-shared/footer';

export const markup = `${navMarkup('catalogue')}

<!-- ──────────────────────────────────────────────
     PAGE HEADER
─────────────────────────────────────────────── -->
<div class="page-hero">
  <div class="container">
    <div class="page-hero-grid">
      <div>
        <div class="eyebrow hero-anim-eyebrow">Exam Catalogue · 18 Assessments</div>
        <h1><span class="word">Eighteen</span> <span class="word">assessments.</span><br><span class="accent"><span class="word">Four</span> <span class="word">tracks.</span></span></h1>
      </div>
      <div class="page-hero-rhs hero-anim-rhs">
        <p>From your first steps in Revit to BIM Champion-level mastery — every exam reflects real industry expectations, not textbook theory. Built by practitioners, aligned to Autodesk ACU and ACP.</p>
        <div class="view-toggle" id="view-toggle">
          <button class="view-btn active" data-view="individual">Individual</button>
          <button class="view-btn" data-view="enterprise">Business</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ──────────────────────────────────────────────
     FILTER BAR (individual only)
─────────────────────────────────────────────── -->
<div class="filter-strip" id="filter-strip">
  <div class="filter-strip-inner">
    <button class="filter-btn active" data-section="all">All</button>
    <button class="filter-btn" data-section="arch">Architecture</button>
    <button class="filter-btn" data-section="interior">Interior</button>
    <button class="filter-btn" data-section="structural">Structural</button>
    <button class="filter-btn" data-section="services">Services Engineering</button>
    <button class="filter-btn" data-section="acp">ACP Preparation</button>
  </div>
</div>

<!-- ══════════════════════════════════════════════
     MAIN
══════════════════════════════════════════════ -->
<main>

<!-- ═══════════ INDIVIDUAL VIEW ═══════════ -->
<div id="view-individual">

  <!-- ── ARCHITECTURE ── -->
  <section class="cat-section reveal" data-section="arch">
    <div class="cat-section-head">
      <div class="section-num">01</div>
      <div class="section-text-block">
        <div class="section-badge badge-arch">Architecture Track</div>
        <h2>Revit Architecture Pathway</h2>
        <p>A progressive journey from first-time user to BIM Champion. All exams include 12 months access with unlimited attempts.</p>
      </div>
      <div class="section-count">8 exams · $39 each</div>
    </div>

    <div class="cards-grid reveal-stagger">
      <div class="exam-card">
        <div class="card-top"><span class="level-pill pill-novice">Novice</span><span class="card-code">ARCH-01</span></div>
        <h3 class="card-title">Novice</h3>
        <p class="card-desc">Interface, navigation, basic element placement, and understanding the BIM environment for the first time.</p>
        <hr class="card-divider">
        <div class="card-topics">UI · Navigation · Basic elements</div>
        <a href="#" class="card-btn">Start exam</a>
      </div>
      <div class="exam-card">
        <div class="card-top"><span class="level-pill pill-foundation">Foundation</span><span class="card-code">ARCH-02</span></div>
        <h3 class="card-title">Foundation</h3>
        <p class="card-desc">Walls, floors, roofs, doors, windows, and basic view management aligned to ACU entry-level competencies.</p>
        <hr class="card-divider">
        <div class="card-topics">Core elements · Views · Properties</div>
        <a href="#" class="card-btn">Start exam</a>
      </div>
      <div class="exam-card">
        <div class="card-top"><span class="level-pill pill-intermediate">Intermediate</span><span class="card-code">ARCH-03</span></div>
        <h3 class="card-title">Family Creation</h3>
        <p class="card-desc">Parametric family creation — reference planes, parameters, constraints, and visibility controls.</p>
        <hr class="card-divider">
        <div class="card-topics">Families · Parameters · Geometry</div>
        <a href="#" class="card-btn">Start exam</a>
      </div>
      <div class="exam-card">
        <div class="card-top"><span class="level-pill pill-intermediate">Intermediate</span><span class="card-code">ARCH-04</span></div>
        <h3 class="card-title">Design Focused</h3>
        <p class="card-desc">Massing, curtain walls, adaptive components, design options, and phasing for early-stage design.</p>
        <hr class="card-divider">
        <div class="card-topics">Massing · Curtain walls · Phasing</div>
        <a href="#" class="card-btn">Start exam</a>
      </div>
      <div class="exam-card">
        <div class="card-top"><span class="level-pill pill-intermediate">Intermediate</span><span class="card-code">ARCH-05</span></div>
        <h3 class="card-title">Detailed Design</h3>
        <p class="card-desc">Compound walls, complex roofs, stairs, railings, openings, and element joins for construction-ready models.</p>
        <hr class="card-divider">
        <div class="card-topics">Advanced elements · Stairs · Joins</div>
        <a href="#" class="card-btn">Start exam</a>
      </div>
      <div class="exam-card">
        <div class="card-top"><span class="level-pill pill-intermediate">Intermediate</span><span class="card-code">ARCH-06</span></div>
        <h3 class="card-title">Documents</h3>
        <p class="card-desc">Sheets, titleblocks, annotation, dimensions, keynotes, schedules, and revision control.</p>
        <hr class="card-divider">
        <div class="card-topics">Sheets · Annotation · Schedules</div>
        <a href="#" class="card-btn">Start exam</a>
      </div>
      <div class="exam-card">
        <div class="card-top"><span class="level-pill pill-advanced">Advanced</span><span class="card-code">ARCH-07</span></div>
        <h3 class="card-title">Advanced</h3>
        <p class="card-desc">Worksharing, worksets, linked models, coordination review, phasing, design options, and project standards.</p>
        <hr class="card-divider">
        <div class="card-topics">Worksharing · Coordination · Standards</div>
        <a href="#" class="card-btn">Start exam</a>
      </div>
      <div class="exam-card">
        <div class="card-top"><span class="level-pill pill-professional">BIM Champion</span><span class="card-code">ARCH-08</span></div>
        <h3 class="card-title">BIM Champion</h3>
        <p class="card-desc">Comprehensive across all domains — modelling, collaboration, documentation, and BIM management.</p>
        <hr class="card-divider">
        <div class="card-topics">All domains · Full benchmark</div>
        <a href="#" class="card-btn primary">Start exam</a>
      </div>
    </div>

    <div class="pack-banner accent reveal">
      <div class="pack-left">
        <div class="pack-eyebrow" style="color:var(--accent);">Architecture Pack</div>
        <h3>Full Architecture Pathway</h3>
        <p>All 8 Architecture exams. One purchase, 12 months unlimited access across all levels.</p>
      </div>
      <div class="pack-right">
        <div>
          <div class="pack-price">$139</div>
          <div class="pack-save" style="color:var(--accent);">Save 55% vs individual</div>
        </div>
        <button class="pack-btn">Get the pack</button>
      </div>
    </div>
  </section>

  <!-- ── INTERIOR DESIGN ── -->
  <section class="cat-section reveal" data-section="interior">
    <div class="cat-section-head">
      <div class="section-num">02</div>
      <div class="section-text-block">
        <div class="section-badge badge-focus">Interior Design</div>
        <h2>Interior Design Track</h2>
        <p>From first principles to specialist competency in interior Revit workflows. 12 months access included.</p>
      </div>
      <div class="section-count">2 exams · $39 each · $69 discipline pack</div>
    </div>

    <div class="discipline-group">
      <div class="discipline-label">Interior Design</div>
      <div class="cards-grid-2col reveal-stagger">
        <div class="exam-card">
          <div class="card-top"><span class="level-pill pill-novice">Novice</span><span class="card-code">INT-01</span></div>
          <h3 class="card-title">Interior Design — Novice</h3>
          <p class="card-desc">Room placement, basic furniture families, simple material application, and interior view setup in Revit.</p>
          <hr class="card-divider">
          <div class="card-topics">Rooms · Furniture · Materials</div>
          <a href="#" class="card-btn">Start exam</a>
        </div>
        <div class="exam-card">
          <div class="card-top"><span class="level-pill pill-specialist">Specialist</span><span class="card-code">INT-02</span></div>
          <h3 class="card-title">Interior Design — Specialist</h3>
          <p class="card-desc">Room tagging, finish schedules, furniture families, ceiling grids, material application, and full interior documentation.</p>
          <hr class="card-divider">
          <div class="card-topics">Finishes · Ceilings · Schedules · Documentation</div>
          <a href="#" class="card-btn">Start exam</a>
        </div>
      </div>
    </div>

    <div class="pack-banner sage-accent reveal">
      <div class="pack-left">
        <div class="pack-eyebrow" style="color:var(--muted);">Discipline Pack</div>
        <h3>Interior Design — Both Levels</h3>
        <p>Novice + Specialist. 12 months unlimited access.</p>
      </div>
      <div class="pack-right">
        <div>
          <div class="pack-price">$69</div>
          <div class="pack-save">Save 12% vs individual</div>
        </div>
        <button class="pack-btn">Get pack</button>
      </div>
    </div>
  </section>

  <!-- ── STRUCTURAL ENGINEERING ── -->
  <section class="cat-section reveal" data-section="structural">
    <div class="cat-section-head">
      <div class="section-num">03</div>
      <div class="section-text-block">
        <div class="section-badge badge-focus">Structural Engineering</div>
        <h2>Structural Engineering Track</h2>
        <p>Novice and Specialist exams for structural engineers using Revit. 12 months access included.</p>
      </div>
      <div class="section-count">2 exams · $39 each · $69 discipline pack</div>
    </div>

    <div class="discipline-group">
      <div class="discipline-label">Structural Engineers</div>
      <div class="cards-grid-2col reveal-stagger">
        <div class="exam-card">
          <div class="card-top"><span class="level-pill pill-novice">Novice</span><span class="card-code">STR-01</span></div>
          <h3 class="card-title">Structural — Novice</h3>
          <p class="card-desc">Placing columns, beams, and structural walls, and understanding the structural template environment in Revit.</p>
          <hr class="card-divider">
          <div class="card-topics">Columns · Beams · Structural walls</div>
          <a href="#" class="card-btn">Start exam</a>
        </div>
        <div class="exam-card">
          <div class="card-top"><span class="level-pill pill-specialist">Specialist</span><span class="card-code">STR-02</span></div>
          <h3 class="card-title">Structural — Specialist</h3>
          <p class="card-desc">Framing, foundations, structural walls, analytical models, rebar placement, and coordination with linked models.</p>
          <hr class="card-divider">
          <div class="card-topics">Framing · Analytical · Rebar · Foundations</div>
          <a href="#" class="card-btn">Start exam</a>
        </div>
      </div>
    </div>

    <div class="pack-banner sage-accent reveal">
      <div class="pack-left">
        <div class="pack-eyebrow" style="color:var(--muted);">Discipline Pack</div>
        <h3>Structural Engineering — Both Levels</h3>
        <p>Novice + Specialist. 12 months unlimited access.</p>
      </div>
      <div class="pack-right">
        <div>
          <div class="pack-price">$69</div>
          <div class="pack-save">Save 12% vs individual</div>
        </div>
        <button class="pack-btn">Get pack</button>
      </div>
    </div>
  </section>

  <!-- ── SERVICES ENGINEERING ── -->
  <section class="cat-section reveal" data-section="services">
    <div class="cat-section-head">
      <div class="section-num">04</div>
      <div class="section-text-block">
        <div class="section-badge badge-focus">Services Engineering</div>
        <h2>Services Engineering Track</h2>
        <p>Novice and Specialist exams for Mechanical, Electrical, and Hydraulic engineers. 12 months access included.</p>
      </div>
      <div class="section-count">6 exams · $39 each · $69 per discipline pack</div>
    </div>

    <div class="discipline-group">
      <div class="discipline-label">Mechanical Engineers</div>
      <div class="cards-grid-2col reveal-stagger">
        <div class="exam-card">
          <div class="card-top"><span class="level-pill pill-novice">Novice</span><span class="card-code">MEC-01</span></div>
          <h3 class="card-title">Mechanical — Novice</h3>
          <p class="card-desc">Mechanical equipment placement, basic duct routing, and system browser navigation in the Revit MEP environment.</p>
          <hr class="card-divider">
          <div class="card-topics">Equipment · Basic ducts · MEP UI</div>
          <a href="#" class="card-btn">Start exam</a>
        </div>
        <div class="exam-card">
          <div class="card-top"><span class="level-pill pill-specialist">Specialist</span><span class="card-code">MEC-02</span></div>
          <h3 class="card-title">Mechanical — Specialist</h3>
          <p class="card-desc">HVAC system creation, duct and pipe routing, mechanical equipment, system browser, and analytical space modelling.</p>
          <hr class="card-divider">
          <div class="card-topics">HVAC · Ducts · Systems · Analytical</div>
          <a href="#" class="card-btn">Start exam</a>
        </div>
      </div>
    </div>

    <div class="discipline-group">
      <div class="discipline-label">Electrical Engineers</div>
      <div class="cards-grid-2col reveal-stagger">
        <div class="exam-card">
          <div class="card-top"><span class="level-pill pill-novice">Novice</span><span class="card-code">ELE-01</span></div>
          <h3 class="card-title">Electrical — Novice</h3>
          <p class="card-desc">Placing lighting fixtures, basic circuit creation, and navigating electrical project settings in Revit.</p>
          <hr class="card-divider">
          <div class="card-topics">Fixtures · Basic circuits · Settings</div>
          <a href="#" class="card-btn">Start exam</a>
        </div>
        <div class="exam-card">
          <div class="card-top"><span class="level-pill pill-specialist">Specialist</span><span class="card-code">ELE-02</span></div>
          <h3 class="card-title">Electrical — Specialist</h3>
          <p class="card-desc">Lighting circuits, power systems, panel schedules, cable tray, conduit routing, and electrical equipment families.</p>
          <hr class="card-divider">
          <div class="card-topics">Circuits · Panels · Conduit · Families</div>
          <a href="#" class="card-btn">Start exam</a>
        </div>
      </div>
    </div>

    <div class="discipline-group">
      <div class="discipline-label">Hydraulic Engineers</div>
      <div class="cards-grid-2col reveal-stagger">
        <div class="exam-card">
          <div class="card-top"><span class="level-pill pill-novice">Novice</span><span class="card-code">HYD-01</span></div>
          <h3 class="card-title">Hydraulic — Novice</h3>
          <p class="card-desc">Basic pipe placement, fixture connection, and understanding hydraulic system types and settings in Revit.</p>
          <hr class="card-divider">
          <div class="card-topics">Pipes · Fixtures · System types</div>
          <a href="#" class="card-btn">Start exam</a>
        </div>
        <div class="exam-card">
          <div class="card-top"><span class="level-pill pill-specialist">Specialist</span><span class="card-code">HYD-02</span></div>
          <h3 class="card-title">Hydraulic — Specialist</h3>
          <p class="card-desc">Pipe systems, fixtures, flow calculations, pipe routing, and full hydraulic system documentation in Revit.</p>
          <hr class="card-divider">
          <div class="card-topics">Pipe systems · Flow · Plumbing docs</div>
          <a href="#" class="card-btn">Start exam</a>
        </div>
      </div>
    </div>

    <div class="pack-banner sage-accent reveal">
      <div class="pack-left">
        <div class="pack-eyebrow" style="color:var(--muted);">Discipline Pack</div>
        <h3>Any Services Discipline — Both Levels</h3>
        <p>Novice + Specialist for Mechanical, Electrical, or Hydraulic. 12 months unlimited access.</p>
      </div>
      <div class="pack-right">
        <div>
          <div class="pack-price">$69</div>
          <div class="pack-save">Save 12% vs individual · per discipline</div>
        </div>
        <button class="pack-btn">Choose discipline</button>
      </div>
    </div>
  </section>

  <!-- ── ACP PREPARATION ── -->
  <section class="cat-section reveal" data-section="acp">
    <div class="cat-section-head">
      <div class="section-num">05</div>
      <div class="section-text-block">
        <div class="section-badge badge-special">Special</div>
        <h2>Autodesk Certification Preparation</h2>
        <p>Purpose-built to prepare you for the official Autodesk Certified Professional exam. 12 months access, unlimited retakes.</p>
      </div>
      <div class="section-count">1 exam · $69 · Unlimited retakes</div>
    </div>

    <div class="acp-card reveal">
      <div class="acp-left">
        <div class="acp-eyebrow">Autodesk Certified Professional</div>
        <h3>The ACP<br><span class="em">Preparation Exam</span></h3>
        <p>The most comprehensive assessment on BIMAssess — purpose-built to mirror the format, question types, and topic weighting of the official Autodesk Certified Professional exam. Covering all five ACP domains: Modelling, Documentation, Collaboration, Project Standards, and Information Analysis.</p>
        <div class="acp-features">
          <span class="acp-feat">Full ACP domain coverage</span>
          <span class="acp-feat">Timed exam conditions</span>
          <span class="acp-feat">Topic breakdown report</span>
          <span class="acp-feat">Unlimited retakes</span>
          <span class="acp-feat">12 months access</span>
          <span class="acp-feat">Pass certificate issued</span>
        </div>
      </div>
      <div class="acp-right">
        <div class="acp-right-label">One-off purchase</div>
        <div class="acp-price">$69</div>
        <div class="acp-price-note">Unlimited retakes included.<br>12 months access.</div>
        <button class="acp-btn">Begin preparation</button>
        <div class="acp-btn-note">Instant access after purchase</div>
      </div>
    </div>
  </section>

</div><!-- end view-individual -->


<!-- ═══════════ ENTERPRISE VIEW ═══════════ -->
<div id="view-enterprise" style="display:none;">

  <section class="cat-section">
    <div class="cat-section-head reveal">
      <div class="section-num">—</div>
      <div class="section-text-block">
        <div class="section-badge badge-ent">Business</div>
        <h2>Candidate &amp; Staff Benchmarking</h2>
        <p>Role-profile assessments for companies building BIM teams and recruitment agencies screening candidates for Revit competency.</p>
      </div>
      <div class="section-count">9 assessments</div>
    </div>

    <div class="ent-intro reveal">
      Role-profile assessments are designed to benchmark candidates and staff against real-world job expectations — not generic exam pathways. Assign any assessment to any person. Results are reported back to your team dashboard with a full skill breakdown.
    </div>

    <!-- Architecture & Design Group -->
    <div class="ent-group">
      <div class="ent-group-label">Architecture &amp; Design</div>
      <div class="cards-grid reveal-stagger">
        <div class="exam-card">
          <div class="card-top"><span class="level-pill pill-foundation">Junior</span><span class="card-code">ENT-AD-01</span></div>
          <h3 class="card-title">Architecture — Junior</h3>
          <p class="card-desc">Benchmarks graduates and entry-level candidates against the Revit fundamentals expected of a junior BIM technician — modelling basics, view management, and simple documentation.</p>
          <hr class="card-divider">
          <div class="card-topics">Suitable for: Graduates, career changers, BIM trainees</div>
          <a href="#" class="card-btn">Assign assessment</a>
        </div>
        <div class="exam-card">
          <div class="card-top"><span class="level-pill pill-intermediate">Senior</span><span class="card-code">ENT-AD-02</span></div>
          <h3 class="card-title">Architecture — Senior</h3>
          <p class="card-desc">Assesses experienced architectural technicians — advanced modelling, worksharing, coordination workflows, documentation standards, and project delivery competency.</p>
          <hr class="card-divider">
          <div class="card-topics">Suitable for: Senior technicians, project architects</div>
          <a href="#" class="card-btn">Assign assessment</a>
        </div>
        <div class="exam-card">
          <div class="card-top"><span class="level-pill pill-advanced">Specialist</span><span class="card-code">ENT-AD-03</span></div>
          <h3 class="card-title">Content Creator</h3>
          <p class="card-desc">Evaluates advanced parametric family creation — reference planes, complex geometry, nested families, shared parameters, and BIM content management workflows.</p>
          <hr class="card-divider">
          <div class="card-topics">Suitable for: BIM authors, content managers, Revit specialists</div>
          <a href="#" class="card-btn">Assign assessment</a>
        </div>
        <div class="exam-card">
          <div class="card-top"><span class="level-pill pill-specialist">Specialist</span><span class="card-code">ENT-AD-04</span></div>
          <h3 class="card-title">Interior Design — Junior</h3>
          <p class="card-desc">Screens candidates for interior design roles — room workflows, finish specification, furniture modelling, ceiling design, and interior documentation competency.</p>
          <hr class="card-divider">
          <div class="card-topics">Suitable for: Interior designers, fit-out specialists, junior ID candidates</div>
          <a href="#" class="card-btn">Assign assessment</a>
        </div>
        <div class="exam-card">
          <div class="card-top"><span class="level-pill pill-professional">Manager</span><span class="card-code">ENT-AD-05</span></div>
          <h3 class="card-title">BIM Manager</h3>
          <p class="card-desc">Comprehensive assessment for BIM Manager candidates — worksharing, project standards, model health, linked files, coordination workflows, and management of Revit environments.</p>
          <hr class="card-divider">
          <div class="card-topics">Suitable for: BIM Managers, BIM Leads, Digital Delivery Leads</div>
          <a href="#" class="card-btn">Assign assessment</a>
        </div>
      </div>
    </div>

    <!-- Engineering Group -->
    <div class="ent-group">
      <div class="ent-group-label sage">Engineering</div>
      <div class="cards-grid reveal-stagger">
        <div class="exam-card">
          <div class="card-top"><span class="level-pill pill-specialist">Specialist</span><span class="card-code">ENT-ENG-01</span></div>
          <h3 class="card-title">Mechanical Engineer</h3>
          <p class="card-desc">HVAC system creation, duct and pipe routing, mechanical equipment placement, system browser, and analytical space modelling in Revit MEP at professional level.</p>
          <hr class="card-divider">
          <div class="card-topics">Suitable for: HVAC engineers, MEP coordinators, mechanical designers</div>
          <a href="#" class="card-btn">Assign assessment</a>
        </div>
        <div class="exam-card">
          <div class="card-top"><span class="level-pill pill-specialist">Specialist</span><span class="card-code">ENT-ENG-02</span></div>
          <h3 class="card-title">Electrical Engineer</h3>
          <p class="card-desc">Lighting circuits, power systems, panel schedules, cable tray, conduit routing, and electrical equipment family competency in Revit at professional level.</p>
          <hr class="card-divider">
          <div class="card-topics">Suitable for: Electrical engineers, ELV designers, power systems engineers</div>
          <a href="#" class="card-btn">Assign assessment</a>
        </div>
        <div class="exam-card">
          <div class="card-top"><span class="level-pill pill-specialist">Specialist</span><span class="card-code">ENT-ENG-03</span></div>
          <h3 class="card-title">Hydraulic Engineer</h3>
          <p class="card-desc">Pipe systems, fixtures, flow calculations, pipe routing, and full hydraulic system documentation in Revit at professional level.</p>
          <hr class="card-divider">
          <div class="card-topics">Suitable for: Hydraulic engineers, plumbing designers, fire services engineers</div>
          <a href="#" class="card-btn">Assign assessment</a>
        </div>
        <div class="exam-card">
          <div class="card-top"><span class="level-pill pill-specialist">Specialist</span><span class="card-code">ENT-ENG-04</span></div>
          <h3 class="card-title">Structural Engineer</h3>
          <p class="card-desc">Framing, foundations, structural walls, analytical models, rebar placement, and coordination with architectural and MEP linked models.</p>
          <hr class="card-divider">
          <div class="card-topics">Suitable for: Structural engineers, detailers, civil-structural designers</div>
          <a href="#" class="card-btn">Assign assessment</a>
        </div>
      </div>
    </div>

  </section>

</div><!-- end view-enterprise -->

</main>

<!-- ──────────────────────────────────────────────
     FINAL CTA
─────────────────────────────────────────────── -->
<section class="final-cta">
  <div class="container">
    <h2>Ready to find out<br>where you <span class="accent">stand?</span></h2>
    <p>Take your first assessment free. No card required.</p>
    <div class="cta-actions">
      <a href="#" class="btn btn-primary">Start free assessment →</a>
      <a href="/pricing" data-spa-link class="btn btn-ghost">View pricing</a>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     FOOTER
─────────────────────────────────────────────── -->

${footerMarkup()}`;
